export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6939.8e5baa5f.jpg";